import React, { useState, useEffect } from "react"
import Header from "./components/Header/index"
import "./styles/global.scss"
import "./styles/main.scss"
import Document from "./components/Document"
import { getParsedData, getToken } from "./data"

function App() {
  const [page, setPage] = useState({})
  const [token, setToken] = useState(false)
  useEffect(() => {
    loadCMSData()
    tokenCall()
  }, [])

  const loadCMSData = async () => {
    const docData = await getParsedData()
    setPage(docData)
  }

  const tokenCall = async () => {
    // Event("DocumentUpload_Start", "start", "Document Upload")
    const token = await getToken()
    if (token) {
      setToken(token)
    }
  }

  return (
    <div className="App">
      {!page.error && page.header && <Header {...page.header} />}
      {token && <Document contentData={page} />}
    </div>
  )
}

export default App
